'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSvg = require('react-svg');

var _reactSvg2 = _interopRequireDefault(_reactSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardHeader = function CardHeader(_ref) {
  var svgName = _ref.svgName,
      svgUrl = _ref.svgUrl;

  var url = void 0;
  if (svgUrl) {
    url = svgUrl;
  } else if (svgName) {
    url = 'https://static.ux.cimpress.io/assets/icons/' + svgName + '.svg';
  }

  return _react2.default.createElement(
    'div',
    {
      style: { padding: '8.5px 1px', maxWidth: '220px', margin: '0 auto', textAlign: 'center', position: 'relative' } },
    _react2.default.createElement(_reactSvg2.default, { path: 'https://static.ux.cimpress.io/assets/icons/card_icon_bg.svg' }),
    _react2.default.createElement(_reactSvg2.default, {
      path: url,
      style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '24px',
        height: '24px'
      }
    })
  );
};

CardHeader.propTypes = {
  svgUrl: _propTypes2.default.string,
  svgName: _propTypes2.default.string
};

exports.default = CardHeader;